// Remove all spaces // Spaces Only
function trimAll(str) {
    return str.trim().replace(/\s+/g, '');
}
module.exports = { trimAll };
